<template>
    <div class="mb-3">
        <h3>Dates</h3>

        <div class="mb-3">
            <div>
                <label>Date of Arrival: <span class="required">*</span></label>
                <VueDatePicker v-model="store.arrivalDate" :enable-time-picker="false" auto-apply model-type="format" format="MM/dd/yyyy" :class="{ 'is-invalid': v$.arrivalDate.$errors.length > 0 }"></VueDatePicker>
            </div>
            <div v-for="error of v$.arrivalDate.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
        </div>

        <div class="mb-3">
            <div>
                <label>Date of Departure: <span class="required">*</span></label>
                <VueDatePicker v-model="store.departureDate" :enable-time-picker="false" auto-apply model-type="format" format="MM/dd/yyyy" :class="{ 'is-invalid': v$.departureDate.$errors.length > 0 }"></VueDatePicker>
            </div>
            <div v-for="error of v$.departureDate.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
        </div>

        <div class="text-center">
            <button type="button" class="btn btn-outline-primary me-3" @click="goBackToPage('AIRCRAFT')">Back</button>
            <button type="button" class="btn btn-primary" @click="goToPage('CONTACT')">Next</button>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import { useStore } from './store';
    import useVuelidate from '@vuelidate/core';
    import { required, helpers } from '@vuelidate/validators';

    const emit = defineEmits(['goToPage', 'goBackToPage']);

    const store = useStore();

    const rules = computed(() => ({
        arrivalDate: { required },
        departureDate: {
            required,
            isAfterStart: helpers.withMessage("Departure date must be after arrival date", (value) => {
                if (!store.arrivalDate || !value) return true

                return new Date(value) > new Date(store.arrivalDate)
            })
        }
    }));

    const v$ = useVuelidate(rules, store);

    async function goToPage(pageName) {
        var isValid = await v$.value.$validate();

        if (isValid)
            emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

</script>